<template>
    <div class="printManagementDialog">
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="900px">
            <div class="dialogContent" v-loading="loading">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
                    <el-form-item label="成果展示名称" prop="productName">
                        <el-input v-model="form.productName" placeholder="请输入成果名称"></el-input>
                    </el-form-item>
                    <el-form-item label="成果展示封面" prop="urlList">
                        <div style="display: flex;flex-wrap: wrap;">
                            <div class="imgListClass" v-for="(item,index) in form.urlList" v-if="item" >
                                <el-image
                                    :src="item.imgUrl" :preview-src-list="previewList">
                                </el-image>
                                <div class="img-cover-wrap">
                                    <i @click.stop="del(index)" class="el-icon-error"></i>
                                </div>
                            </div>
                        </div>
                        <el-upload v-if="isShow"
                            action="/service-center/upload/file/single"
                            :headers="headers"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload" class="thumbnailClass">
                            <div class="avatar">
                                <el-button>点击上传</el-button>
                            </div>
                        </el-upload>
                         <span style="color:#DCDFE6">请上传长:208px,宽:130px的图片</span>
                    </el-form-item>
                    <el-form-item label="成果展示详情" prop="remark" class="remark">
                        <vue-editor v-model="form.remark" useCustomImageHandler
                                    @image-added="handleImageAdded" style="width: 100%" />
                        <!--<el-input type="textarea" :autosize="{ minRows: 6}" v-model="form.remark" placeholder="请输入成果详情"></el-input>-->
                    </el-form-item>
                    <!--<el-form-item prop="sort" label="排序">
                        <el-input-number v-model="form.sort" :min="1"></el-input-number>
                    </el-form-item>-->
                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {
        getProductList,
        addProductList,
        delProductList,
        getProductDetail,
        uploadPicture,
    } from "../../utils/interface";
    export default {
        data() {
            return {
                isShow:true,
                id: null,
                dialogVisible: false,
                loading: false,
                title: '',
                headers: {
                    'Authorization': 'Bearer ' + this.$cookies.get("api_access_token")
                },
                form: {
                    productName: '',
                    urlList: [],
                    sort: '1',
                    remark:"",
                    productType:'PRODUCT',
                },
                rules: {
                    productName: [
                        {required: true, message: '请输入成果名称', trigger: 'blur'}
                    ],
                    urlList: [
                        {required: true, message: '请上传图片',trigger:["change"]}
                    ],
                    sort: [
                        {required: true, message: '请设置排序',trigger: 'change'}
                    ],
                    remark: [
                        {required: true, message: '请输入成果详情',trigger: 'change'}
                    ],
                },
                previewList: []
            }
        },
        components: {},
        methods: {
            handleImageAdded(file, Editor, cursorLocation, resetUploader) {
                //formDta是个对象，用来模拟表单的
                let formData = new FormData()
                formData.append('file', file)
                uploadPicture(formData).then(response =>{
                    console.log(response)
                    Editor.insertEmbed(cursorLocation, 'image', response.url)
                    resetUploader()
                })
            },
            init(type,item) {
                this.dialogVisible = true
                this.reset()
                if (type === 'add') {
                    this.title = '新增'
                    this.id = null;
                    this.isShow = true
                } else {
                    this.title = '编辑'
                    this.form = item;
                    // this.getDetail(id)
                    this.isShow = false
                }
            },
            // 效果图上传
            handleAvatarSuccess(res, file) {
                this.form.urlList.push({
                    productUuid : this.id,
                    name: res.name,
                    imgUrl: res.url
                })
                this.previewList.push(res.url)
                this.$refs.ruleForm.validateField('urlList')
                this.imageListLength( this.form.urlList)
                this.beforeAvatarUpload(res.url)
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type.indexOf('image') !== -1;
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.warning('上传图片只能是图片格式!');
                }
                if (!isLt2M) {
                    this.$message.warning('上传图片大小不能超过 2MB!');
                }
                const isSize = new Promise(function (resolve, reject) {
                    const width = 208
                    const height = 130
                    const URL = window.URL || window.webkitURL
                    const img = new Image()
                    img.onload = function () {
                        const valid = img.width === width && img.height === height
                        valid ? resolve() : reject()
                    }
                    img.src = URL.createObjectURL(file)
                }).then( () => {
                    return file
                },
                () => {
                    this.$message.error('请上传长:208px,宽:130px')
                    return Promise.reject()
                })
                return isJPG && isLt2M && isSize;
            },
            reset(){
                this.previewList = []
                this.form = {
                    productName : '',
                    urlList: [],
                    sort: '1',
                    productType:'PRODUCT',
                }
            },
            // 图片删除
            del(index){
                this.form.urlList.splice(index,1)
                this.previewList.splice(index,1)
                this.$refs.ruleForm.validateField('urlList')
                this.imageListLength(index)
            },
             // 当前图片的个数
                imageListLength(val){
                if (val.length > 0 ) {
                    this.isShow = false
                }else {
                    this.isShow = true
                }
                },
            // 提交
            submit(){
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        this.loading = true
                        addProductList({
                                    uuid: this.id,
                                    ...this.form
                                }).then((res) => {
                            if (res.success) {
                                // this.alert(true, "success", "", true);
                                this.$alert("提交成功", "提示", {
                                    confirmButtonText: "确定",
                                    // callback: (action) => {
                                    //     this.$message({
                                    //         type: "info",
                                    //         message: `action: ${action}`,
                                    //     });
                                    // },
                                });
                                this.reset();
                                this.$emit('submit');
                            }
                            console.log(res);
                        });
                        this.loading = false;
                        this.dialogVisible = false;
                    } else {
                        return false;
                    }
                });
            },
            // 查询详情
            getDetail(id){
                // 获取详情接口
                getProductDetail({uuid:id}).then((res)=>{
                    console.log(res);
                    this.form = res
                })
            }
        }
    }
</script>

<style scoped lang="less">
    .dialogContent {
        padding: 0 5%;
        /deep/.el-upload-list--picture-card .el-upload-list__item{
            width: 80px;
            height: 80px;
        }
        /deep/.el-upload--picture-card{
            width: 80px;
            height: 80px;
            line-height: 80px;
        }
        /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail{
            width: 80px;
            height: 80px;
        }
        /deep/.el-image__inner{
            width: 275px;
            height: 150px;
        }
        .remark{
           /deep/ .ql-editor{
               height: 425px;
            }
        }
        .thumbnailClass{
            button{
                width: 100px;
                background: #3d7fff;
                border: none;
                border-radius: 5px;
                font-size: 14px;
                color: #FFFFFF;
            }
        }
        .imgListClass{
            width: 275px;
            height: 150px;
            border: solid 1px #ececec;
            background-color: #f9f9f9;
            margin-right: 13px;
            margin-bottom: 13px;
            position: relative;
            &:hover{
                .img-cover-wrap{
                    display: block;
                }
            }
            /deep/.el-image__preview{
                width: 275px;
                height: 150px;
            }
            // 删除
            .img-cover-wrap {
                right: 5px;
                top: 5px;
                position: absolute;
                line-height: initial;
                display: none;
                i {
                    font-size: 22px;
                    color: #000;
                    display: inline;
                    cursor: pointer;
                }
            }
        }
        .endPeriodClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
            }
        }
        .submitButtonClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
                text-align: center;
                button{
                    padding: 0;
                    width: 120px;
                    height: 35px;
                    line-height: 35px;
                    border-radius: 6px;
                }
            }
        }
        .detailsClass{
            /*/deep/.el-form-item__label{*/
            /*float: none;*/
            /*}*/
            /*/deep/.el-form-item__content{*/
            /*margin-left: 0 !important;*/
            /*}*/
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/production/productDisplayDialog.vue